import whyUseContentData from "../../../../content/home/whyUseContent";
import StickyNote from "./StickyNote";

function WhyUseContent() {
    return (
        <section className="relative py-16 md:py-32">
            <img
                src="/images/home/whyUseSection/whySectionWave.webp"
                alt="image for ui"
                className="absolute top-0 right-0 hidden min-[999px]:block w-[200px] xl:w-[250px]"
            />

            <div className="container flex flex-col items-center justify-center mx-auto">
                <header className="mb-10 text-center">
                    <h2 className="pb-3 text-3xl font-bold tracking-wide md:text-6xl text-text-color-primary">
                        {whyUseContentData.header.title}
                    </h2>
                    <p className="text-2xl font-semibold md:text-3xl text-text-color-primary">
                        {whyUseContentData.header.subtitle}
                    </p>
                </header>
                <div className="flex flex-wrap items-center justify-center gap-10 pt-5">
                    {whyUseContentData.stickyNotes.map((note, index) => (
                        <StickyNote
                            key={index}
                            icon={note.icon}
                            title={note.title}
                            description={note.description}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default WhyUseContent;
